import toastr from 'toastr'

toastr.options = {
  closeButton: true,
  debug: false,
  newestOnTop: true,
  progressBar: false,
  positionClass: "toast-top-right",
  preventDuplicates: true,
  onclick: null,
  showDuration: 300,
  hideDuration: 1000,
  timeOut: 5000,
  extendedTimeOut: 10000,
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut"
};

const notifySuccess = (message, title = null) => {
  toastr.success(message, title || 'Success')
}

const notifyError = (message, title = null) => {
  toastr.error(message, title || 'Error')
}

const notifyWarning = (message, title = null) => {
  toastr.warning(message, title || 'Warning')
}

const notifyInfo = (message, title = null) => {
  toastr.info(message, title || 'Info')
}

export { notifySuccess, notifyError, notifyWarning, notifyInfo }
